const customerFeedbackEvents = {
  action: "customer-feedback",
  labels: {
    dashboard: {
      thumbsUp: "dashboard:thumbs-up",
      thumbsDown: "dashboard:thumbs-down",
    },
    styleQuiz: {
      thumbsUp: (styleGroup) => `style-quiz:${styleGroup}:thumbs-up`,
      thumbsDown: (styleGroup) => `style-quiz:${styleGroup}:thumbs-down`,
    },
  },
};

export default customerFeedbackEvents;
